/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import achievementsApi from '@/services/achievements-api';

const state = {
  participantAchievements: null,
  teamAchievements: null,
  teamAchievementParticipants: null,
  responseStatus: null,
};

const mutations = {
  setParticipantAchievements(state, value) {
    state.participantAchievements = value;
  },
  setTeamAchievements(state, value) {
    state.teamAchievements = value;
  },
  setTeamAchievementParticipants(state, value) {
    state.teamAchievementParticipants = value;
  },
  setResponseStatus(state, value) {
    state.responseStatus = value;
  },
};

const getters = {
  participantAchievements: (state) => state.participantAchievements,
  teamAchievements: (state) => state.teamAchievements,
  teamAchievementParticipants: (state) => state.teamAchievementParticipants,
  responseStatus: (state) => state.responseStatus,
};

const actions = {
  getParticipantAchievements({ commit }, participantId) {
    return achievementsApi.getParticipantAchievements({ participantId })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setParticipantAchievements', response.data);
        } else {
          commit('setParticipantAchievements', null);
        }
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getTeamAchievements({ commit }, teamId) {
    return achievementsApi.getTeamAchievements({ teamId })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setTeamAchievements', response.data);
        } else {
          commit('setTeamAchievements', null);
        }
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getTeamAchievementParticipants({ commit }, teamAchievementId) {
    return achievementsApi.getTeamAchievementsParticipants({ teamAchievementId })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setTeamAchievementParticipants', response.data);
        } else {
          commit('setTeamAchievementParticipants', null);
        }
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
